/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as IndexImport } from './routes/index'
import { Route as StAdminDashboardImport } from './routes/st-admin/dashboard'
import { Route as MarketDashboardImport } from './routes/_market/dashboard'
import { Route as LoginLoginImport } from './routes/_login/login'
import { Route as StAdminUsersIndexImport } from './routes/st-admin/users/index'
import { Route as StAdminTransferPlayersIndexImport } from './routes/st-admin/transfer-players/index'
import { Route as StAdminTransactionsIndexImport } from './routes/st-admin/transactions/index'
import { Route as StAdminTicketsIndexImport } from './routes/st-admin/tickets/index'
import { Route as StAdminSettingsIndexImport } from './routes/st-admin/settings/index'
import { Route as StAdminProfileIndexImport } from './routes/st-admin/profile/index'
import { Route as StAdminPaymentsIndexImport } from './routes/st-admin/payments/index'
import { Route as StAdminManagementIndexImport } from './routes/st-admin/management/index'
import { Route as StAdminBannersIndexImport } from './routes/st-admin/banners/index'
import { Route as MarketSettingsIndexImport } from './routes/_market/settings/index'
import { Route as MarketSendersIndexImport } from './routes/_market/senders/index'
import { Route as MarketRelationsIndexImport } from './routes/_market/relations/index'
import { Route as MarketProxyIndexImport } from './routes/_market/proxy/index'
import { Route as MarketProfileIndexImport } from './routes/_market/profile/index'
import { Route as MarketPaymentIndexImport } from './routes/_market/payment/index'
import { Route as MarketOrdersIndexImport } from './routes/_market/orders/index'
import { Route as MarketSendersNewImport } from './routes/_market/senders/new'
import { Route as MarketSendersSenderIdImport } from './routes/_market/senders/$senderId'
import { Route as MarketRelationsSellerImport } from './routes/_market/relations/seller'
import { Route as MarketRelationsBuyerImport } from './routes/_market/relations/buyer'
import { Route as MarketProxyNewImport } from './routes/_market/proxy/new'
import { Route as MarketOrdersOrderIdImport } from './routes/_market/orders/$orderId'
import { Route as MarketRelationsSellersRelationIdImport } from './routes/_market/relations/sellers/$relationId'
import { Route as MarketRelationsBuyersRelationIdImport } from './routes/_market/relations/buyers/$relationId'

// Create/Update Routes

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const StAdminDashboardRoute = StAdminDashboardImport.update({
  id: '/st-admin/dashboard',
  path: '/st-admin/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const MarketDashboardRoute = MarketDashboardImport.update({
  id: '/_market/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const LoginLoginRoute = LoginLoginImport.update({
  id: '/_login/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const StAdminUsersIndexRoute = StAdminUsersIndexImport.update({
  id: '/st-admin/users/',
  path: '/st-admin/users/',
  getParentRoute: () => rootRoute,
} as any)

const StAdminTransferPlayersIndexRoute =
  StAdminTransferPlayersIndexImport.update({
    id: '/st-admin/transfer-players/',
    path: '/st-admin/transfer-players/',
    getParentRoute: () => rootRoute,
  } as any)

const StAdminTransactionsIndexRoute = StAdminTransactionsIndexImport.update({
  id: '/st-admin/transactions/',
  path: '/st-admin/transactions/',
  getParentRoute: () => rootRoute,
} as any)

const StAdminTicketsIndexRoute = StAdminTicketsIndexImport.update({
  id: '/st-admin/tickets/',
  path: '/st-admin/tickets/',
  getParentRoute: () => rootRoute,
} as any)

const StAdminSettingsIndexRoute = StAdminSettingsIndexImport.update({
  id: '/st-admin/settings/',
  path: '/st-admin/settings/',
  getParentRoute: () => rootRoute,
} as any)

const StAdminProfileIndexRoute = StAdminProfileIndexImport.update({
  id: '/st-admin/profile/',
  path: '/st-admin/profile/',
  getParentRoute: () => rootRoute,
} as any)

const StAdminPaymentsIndexRoute = StAdminPaymentsIndexImport.update({
  id: '/st-admin/payments/',
  path: '/st-admin/payments/',
  getParentRoute: () => rootRoute,
} as any)

const StAdminManagementIndexRoute = StAdminManagementIndexImport.update({
  id: '/st-admin/management/',
  path: '/st-admin/management/',
  getParentRoute: () => rootRoute,
} as any)

const StAdminBannersIndexRoute = StAdminBannersIndexImport.update({
  id: '/st-admin/banners/',
  path: '/st-admin/banners/',
  getParentRoute: () => rootRoute,
} as any)

const MarketSettingsIndexRoute = MarketSettingsIndexImport.update({
  id: '/_market/settings/',
  path: '/settings/',
  getParentRoute: () => rootRoute,
} as any)

const MarketSendersIndexRoute = MarketSendersIndexImport.update({
  id: '/_market/senders/',
  path: '/senders/',
  getParentRoute: () => rootRoute,
} as any)

const MarketRelationsIndexRoute = MarketRelationsIndexImport.update({
  id: '/_market/relations/',
  path: '/relations/',
  getParentRoute: () => rootRoute,
} as any)

const MarketProxyIndexRoute = MarketProxyIndexImport.update({
  id: '/_market/proxy/',
  path: '/proxy/',
  getParentRoute: () => rootRoute,
} as any)

const MarketProfileIndexRoute = MarketProfileIndexImport.update({
  id: '/_market/profile/',
  path: '/profile/',
  getParentRoute: () => rootRoute,
} as any)

const MarketPaymentIndexRoute = MarketPaymentIndexImport.update({
  id: '/_market/payment/',
  path: '/payment/',
  getParentRoute: () => rootRoute,
} as any)

const MarketOrdersIndexRoute = MarketOrdersIndexImport.update({
  id: '/_market/orders/',
  path: '/orders/',
  getParentRoute: () => rootRoute,
} as any)

const MarketSendersNewRoute = MarketSendersNewImport.update({
  id: '/_market/senders/new',
  path: '/senders/new',
  getParentRoute: () => rootRoute,
} as any)

const MarketSendersSenderIdRoute = MarketSendersSenderIdImport.update({
  id: '/_market/senders/$senderId',
  path: '/senders/$senderId',
  getParentRoute: () => rootRoute,
} as any)

const MarketRelationsSellerRoute = MarketRelationsSellerImport.update({
  id: '/_market/relations/seller',
  path: '/relations/seller',
  getParentRoute: () => rootRoute,
} as any)

const MarketRelationsBuyerRoute = MarketRelationsBuyerImport.update({
  id: '/_market/relations/buyer',
  path: '/relations/buyer',
  getParentRoute: () => rootRoute,
} as any)

const MarketProxyNewRoute = MarketProxyNewImport.update({
  id: '/_market/proxy/new',
  path: '/proxy/new',
  getParentRoute: () => rootRoute,
} as any)

const MarketOrdersOrderIdRoute = MarketOrdersOrderIdImport.update({
  id: '/_market/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => rootRoute,
} as any)

const MarketRelationsSellersRelationIdRoute =
  MarketRelationsSellersRelationIdImport.update({
    id: '/_market/relations/sellers/$relationId',
    path: '/relations/sellers/$relationId',
    getParentRoute: () => rootRoute,
  } as any)

const MarketRelationsBuyersRelationIdRoute =
  MarketRelationsBuyersRelationIdImport.update({
    id: '/_market/relations/buyers/$relationId',
    path: '/relations/buyers/$relationId',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_login/login': {
      id: '/_login/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLoginImport
      parentRoute: typeof rootRoute
    }
    '/_market/dashboard': {
      id: '/_market/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof MarketDashboardImport
      parentRoute: typeof rootRoute
    }
    '/st-admin/dashboard': {
      id: '/st-admin/dashboard'
      path: '/st-admin/dashboard'
      fullPath: '/st-admin/dashboard'
      preLoaderRoute: typeof StAdminDashboardImport
      parentRoute: typeof rootRoute
    }
    '/_market/orders/$orderId': {
      id: '/_market/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof MarketOrdersOrderIdImport
      parentRoute: typeof rootRoute
    }
    '/_market/proxy/new': {
      id: '/_market/proxy/new'
      path: '/proxy/new'
      fullPath: '/proxy/new'
      preLoaderRoute: typeof MarketProxyNewImport
      parentRoute: typeof rootRoute
    }
    '/_market/relations/buyer': {
      id: '/_market/relations/buyer'
      path: '/relations/buyer'
      fullPath: '/relations/buyer'
      preLoaderRoute: typeof MarketRelationsBuyerImport
      parentRoute: typeof rootRoute
    }
    '/_market/relations/seller': {
      id: '/_market/relations/seller'
      path: '/relations/seller'
      fullPath: '/relations/seller'
      preLoaderRoute: typeof MarketRelationsSellerImport
      parentRoute: typeof rootRoute
    }
    '/_market/senders/$senderId': {
      id: '/_market/senders/$senderId'
      path: '/senders/$senderId'
      fullPath: '/senders/$senderId'
      preLoaderRoute: typeof MarketSendersSenderIdImport
      parentRoute: typeof rootRoute
    }
    '/_market/senders/new': {
      id: '/_market/senders/new'
      path: '/senders/new'
      fullPath: '/senders/new'
      preLoaderRoute: typeof MarketSendersNewImport
      parentRoute: typeof rootRoute
    }
    '/_market/orders/': {
      id: '/_market/orders/'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof MarketOrdersIndexImport
      parentRoute: typeof rootRoute
    }
    '/_market/payment/': {
      id: '/_market/payment/'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof MarketPaymentIndexImport
      parentRoute: typeof rootRoute
    }
    '/_market/profile/': {
      id: '/_market/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof MarketProfileIndexImport
      parentRoute: typeof rootRoute
    }
    '/_market/proxy/': {
      id: '/_market/proxy/'
      path: '/proxy'
      fullPath: '/proxy'
      preLoaderRoute: typeof MarketProxyIndexImport
      parentRoute: typeof rootRoute
    }
    '/_market/relations/': {
      id: '/_market/relations/'
      path: '/relations'
      fullPath: '/relations'
      preLoaderRoute: typeof MarketRelationsIndexImport
      parentRoute: typeof rootRoute
    }
    '/_market/senders/': {
      id: '/_market/senders/'
      path: '/senders'
      fullPath: '/senders'
      preLoaderRoute: typeof MarketSendersIndexImport
      parentRoute: typeof rootRoute
    }
    '/_market/settings/': {
      id: '/_market/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof MarketSettingsIndexImport
      parentRoute: typeof rootRoute
    }
    '/st-admin/banners/': {
      id: '/st-admin/banners/'
      path: '/st-admin/banners'
      fullPath: '/st-admin/banners'
      preLoaderRoute: typeof StAdminBannersIndexImport
      parentRoute: typeof rootRoute
    }
    '/st-admin/management/': {
      id: '/st-admin/management/'
      path: '/st-admin/management'
      fullPath: '/st-admin/management'
      preLoaderRoute: typeof StAdminManagementIndexImport
      parentRoute: typeof rootRoute
    }
    '/st-admin/payments/': {
      id: '/st-admin/payments/'
      path: '/st-admin/payments'
      fullPath: '/st-admin/payments'
      preLoaderRoute: typeof StAdminPaymentsIndexImport
      parentRoute: typeof rootRoute
    }
    '/st-admin/profile/': {
      id: '/st-admin/profile/'
      path: '/st-admin/profile'
      fullPath: '/st-admin/profile'
      preLoaderRoute: typeof StAdminProfileIndexImport
      parentRoute: typeof rootRoute
    }
    '/st-admin/settings/': {
      id: '/st-admin/settings/'
      path: '/st-admin/settings'
      fullPath: '/st-admin/settings'
      preLoaderRoute: typeof StAdminSettingsIndexImport
      parentRoute: typeof rootRoute
    }
    '/st-admin/tickets/': {
      id: '/st-admin/tickets/'
      path: '/st-admin/tickets'
      fullPath: '/st-admin/tickets'
      preLoaderRoute: typeof StAdminTicketsIndexImport
      parentRoute: typeof rootRoute
    }
    '/st-admin/transactions/': {
      id: '/st-admin/transactions/'
      path: '/st-admin/transactions'
      fullPath: '/st-admin/transactions'
      preLoaderRoute: typeof StAdminTransactionsIndexImport
      parentRoute: typeof rootRoute
    }
    '/st-admin/transfer-players/': {
      id: '/st-admin/transfer-players/'
      path: '/st-admin/transfer-players'
      fullPath: '/st-admin/transfer-players'
      preLoaderRoute: typeof StAdminTransferPlayersIndexImport
      parentRoute: typeof rootRoute
    }
    '/st-admin/users/': {
      id: '/st-admin/users/'
      path: '/st-admin/users'
      fullPath: '/st-admin/users'
      preLoaderRoute: typeof StAdminUsersIndexImport
      parentRoute: typeof rootRoute
    }
    '/_market/relations/buyers/$relationId': {
      id: '/_market/relations/buyers/$relationId'
      path: '/relations/buyers/$relationId'
      fullPath: '/relations/buyers/$relationId'
      preLoaderRoute: typeof MarketRelationsBuyersRelationIdImport
      parentRoute: typeof rootRoute
    }
    '/_market/relations/sellers/$relationId': {
      id: '/_market/relations/sellers/$relationId'
      path: '/relations/sellers/$relationId'
      fullPath: '/relations/sellers/$relationId'
      preLoaderRoute: typeof MarketRelationsSellersRelationIdImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginLoginRoute
  '/dashboard': typeof MarketDashboardRoute
  '/st-admin/dashboard': typeof StAdminDashboardRoute
  '/orders/$orderId': typeof MarketOrdersOrderIdRoute
  '/proxy/new': typeof MarketProxyNewRoute
  '/relations/buyer': typeof MarketRelationsBuyerRoute
  '/relations/seller': typeof MarketRelationsSellerRoute
  '/senders/$senderId': typeof MarketSendersSenderIdRoute
  '/senders/new': typeof MarketSendersNewRoute
  '/orders': typeof MarketOrdersIndexRoute
  '/payment': typeof MarketPaymentIndexRoute
  '/profile': typeof MarketProfileIndexRoute
  '/proxy': typeof MarketProxyIndexRoute
  '/relations': typeof MarketRelationsIndexRoute
  '/senders': typeof MarketSendersIndexRoute
  '/settings': typeof MarketSettingsIndexRoute
  '/st-admin/banners': typeof StAdminBannersIndexRoute
  '/st-admin/management': typeof StAdminManagementIndexRoute
  '/st-admin/payments': typeof StAdminPaymentsIndexRoute
  '/st-admin/profile': typeof StAdminProfileIndexRoute
  '/st-admin/settings': typeof StAdminSettingsIndexRoute
  '/st-admin/tickets': typeof StAdminTicketsIndexRoute
  '/st-admin/transactions': typeof StAdminTransactionsIndexRoute
  '/st-admin/transfer-players': typeof StAdminTransferPlayersIndexRoute
  '/st-admin/users': typeof StAdminUsersIndexRoute
  '/relations/buyers/$relationId': typeof MarketRelationsBuyersRelationIdRoute
  '/relations/sellers/$relationId': typeof MarketRelationsSellersRelationIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginLoginRoute
  '/dashboard': typeof MarketDashboardRoute
  '/st-admin/dashboard': typeof StAdminDashboardRoute
  '/orders/$orderId': typeof MarketOrdersOrderIdRoute
  '/proxy/new': typeof MarketProxyNewRoute
  '/relations/buyer': typeof MarketRelationsBuyerRoute
  '/relations/seller': typeof MarketRelationsSellerRoute
  '/senders/$senderId': typeof MarketSendersSenderIdRoute
  '/senders/new': typeof MarketSendersNewRoute
  '/orders': typeof MarketOrdersIndexRoute
  '/payment': typeof MarketPaymentIndexRoute
  '/profile': typeof MarketProfileIndexRoute
  '/proxy': typeof MarketProxyIndexRoute
  '/relations': typeof MarketRelationsIndexRoute
  '/senders': typeof MarketSendersIndexRoute
  '/settings': typeof MarketSettingsIndexRoute
  '/st-admin/banners': typeof StAdminBannersIndexRoute
  '/st-admin/management': typeof StAdminManagementIndexRoute
  '/st-admin/payments': typeof StAdminPaymentsIndexRoute
  '/st-admin/profile': typeof StAdminProfileIndexRoute
  '/st-admin/settings': typeof StAdminSettingsIndexRoute
  '/st-admin/tickets': typeof StAdminTicketsIndexRoute
  '/st-admin/transactions': typeof StAdminTransactionsIndexRoute
  '/st-admin/transfer-players': typeof StAdminTransferPlayersIndexRoute
  '/st-admin/users': typeof StAdminUsersIndexRoute
  '/relations/buyers/$relationId': typeof MarketRelationsBuyersRelationIdRoute
  '/relations/sellers/$relationId': typeof MarketRelationsSellersRelationIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_login/login': typeof LoginLoginRoute
  '/_market/dashboard': typeof MarketDashboardRoute
  '/st-admin/dashboard': typeof StAdminDashboardRoute
  '/_market/orders/$orderId': typeof MarketOrdersOrderIdRoute
  '/_market/proxy/new': typeof MarketProxyNewRoute
  '/_market/relations/buyer': typeof MarketRelationsBuyerRoute
  '/_market/relations/seller': typeof MarketRelationsSellerRoute
  '/_market/senders/$senderId': typeof MarketSendersSenderIdRoute
  '/_market/senders/new': typeof MarketSendersNewRoute
  '/_market/orders/': typeof MarketOrdersIndexRoute
  '/_market/payment/': typeof MarketPaymentIndexRoute
  '/_market/profile/': typeof MarketProfileIndexRoute
  '/_market/proxy/': typeof MarketProxyIndexRoute
  '/_market/relations/': typeof MarketRelationsIndexRoute
  '/_market/senders/': typeof MarketSendersIndexRoute
  '/_market/settings/': typeof MarketSettingsIndexRoute
  '/st-admin/banners/': typeof StAdminBannersIndexRoute
  '/st-admin/management/': typeof StAdminManagementIndexRoute
  '/st-admin/payments/': typeof StAdminPaymentsIndexRoute
  '/st-admin/profile/': typeof StAdminProfileIndexRoute
  '/st-admin/settings/': typeof StAdminSettingsIndexRoute
  '/st-admin/tickets/': typeof StAdminTicketsIndexRoute
  '/st-admin/transactions/': typeof StAdminTransactionsIndexRoute
  '/st-admin/transfer-players/': typeof StAdminTransferPlayersIndexRoute
  '/st-admin/users/': typeof StAdminUsersIndexRoute
  '/_market/relations/buyers/$relationId': typeof MarketRelationsBuyersRelationIdRoute
  '/_market/relations/sellers/$relationId': typeof MarketRelationsSellersRelationIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/st-admin/dashboard'
    | '/orders/$orderId'
    | '/proxy/new'
    | '/relations/buyer'
    | '/relations/seller'
    | '/senders/$senderId'
    | '/senders/new'
    | '/orders'
    | '/payment'
    | '/profile'
    | '/proxy'
    | '/relations'
    | '/senders'
    | '/settings'
    | '/st-admin/banners'
    | '/st-admin/management'
    | '/st-admin/payments'
    | '/st-admin/profile'
    | '/st-admin/settings'
    | '/st-admin/tickets'
    | '/st-admin/transactions'
    | '/st-admin/transfer-players'
    | '/st-admin/users'
    | '/relations/buyers/$relationId'
    | '/relations/sellers/$relationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard'
    | '/st-admin/dashboard'
    | '/orders/$orderId'
    | '/proxy/new'
    | '/relations/buyer'
    | '/relations/seller'
    | '/senders/$senderId'
    | '/senders/new'
    | '/orders'
    | '/payment'
    | '/profile'
    | '/proxy'
    | '/relations'
    | '/senders'
    | '/settings'
    | '/st-admin/banners'
    | '/st-admin/management'
    | '/st-admin/payments'
    | '/st-admin/profile'
    | '/st-admin/settings'
    | '/st-admin/tickets'
    | '/st-admin/transactions'
    | '/st-admin/transfer-players'
    | '/st-admin/users'
    | '/relations/buyers/$relationId'
    | '/relations/sellers/$relationId'
  id:
    | '__root__'
    | '/'
    | '/_login/login'
    | '/_market/dashboard'
    | '/st-admin/dashboard'
    | '/_market/orders/$orderId'
    | '/_market/proxy/new'
    | '/_market/relations/buyer'
    | '/_market/relations/seller'
    | '/_market/senders/$senderId'
    | '/_market/senders/new'
    | '/_market/orders/'
    | '/_market/payment/'
    | '/_market/profile/'
    | '/_market/proxy/'
    | '/_market/relations/'
    | '/_market/senders/'
    | '/_market/settings/'
    | '/st-admin/banners/'
    | '/st-admin/management/'
    | '/st-admin/payments/'
    | '/st-admin/profile/'
    | '/st-admin/settings/'
    | '/st-admin/tickets/'
    | '/st-admin/transactions/'
    | '/st-admin/transfer-players/'
    | '/st-admin/users/'
    | '/_market/relations/buyers/$relationId'
    | '/_market/relations/sellers/$relationId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginLoginRoute: typeof LoginLoginRoute
  MarketDashboardRoute: typeof MarketDashboardRoute
  StAdminDashboardRoute: typeof StAdminDashboardRoute
  MarketOrdersOrderIdRoute: typeof MarketOrdersOrderIdRoute
  MarketProxyNewRoute: typeof MarketProxyNewRoute
  MarketRelationsBuyerRoute: typeof MarketRelationsBuyerRoute
  MarketRelationsSellerRoute: typeof MarketRelationsSellerRoute
  MarketSendersSenderIdRoute: typeof MarketSendersSenderIdRoute
  MarketSendersNewRoute: typeof MarketSendersNewRoute
  MarketOrdersIndexRoute: typeof MarketOrdersIndexRoute
  MarketPaymentIndexRoute: typeof MarketPaymentIndexRoute
  MarketProfileIndexRoute: typeof MarketProfileIndexRoute
  MarketProxyIndexRoute: typeof MarketProxyIndexRoute
  MarketRelationsIndexRoute: typeof MarketRelationsIndexRoute
  MarketSendersIndexRoute: typeof MarketSendersIndexRoute
  MarketSettingsIndexRoute: typeof MarketSettingsIndexRoute
  StAdminBannersIndexRoute: typeof StAdminBannersIndexRoute
  StAdminManagementIndexRoute: typeof StAdminManagementIndexRoute
  StAdminPaymentsIndexRoute: typeof StAdminPaymentsIndexRoute
  StAdminProfileIndexRoute: typeof StAdminProfileIndexRoute
  StAdminSettingsIndexRoute: typeof StAdminSettingsIndexRoute
  StAdminTicketsIndexRoute: typeof StAdminTicketsIndexRoute
  StAdminTransactionsIndexRoute: typeof StAdminTransactionsIndexRoute
  StAdminTransferPlayersIndexRoute: typeof StAdminTransferPlayersIndexRoute
  StAdminUsersIndexRoute: typeof StAdminUsersIndexRoute
  MarketRelationsBuyersRelationIdRoute: typeof MarketRelationsBuyersRelationIdRoute
  MarketRelationsSellersRelationIdRoute: typeof MarketRelationsSellersRelationIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginLoginRoute: LoginLoginRoute,
  MarketDashboardRoute: MarketDashboardRoute,
  StAdminDashboardRoute: StAdminDashboardRoute,
  MarketOrdersOrderIdRoute: MarketOrdersOrderIdRoute,
  MarketProxyNewRoute: MarketProxyNewRoute,
  MarketRelationsBuyerRoute: MarketRelationsBuyerRoute,
  MarketRelationsSellerRoute: MarketRelationsSellerRoute,
  MarketSendersSenderIdRoute: MarketSendersSenderIdRoute,
  MarketSendersNewRoute: MarketSendersNewRoute,
  MarketOrdersIndexRoute: MarketOrdersIndexRoute,
  MarketPaymentIndexRoute: MarketPaymentIndexRoute,
  MarketProfileIndexRoute: MarketProfileIndexRoute,
  MarketProxyIndexRoute: MarketProxyIndexRoute,
  MarketRelationsIndexRoute: MarketRelationsIndexRoute,
  MarketSendersIndexRoute: MarketSendersIndexRoute,
  MarketSettingsIndexRoute: MarketSettingsIndexRoute,
  StAdminBannersIndexRoute: StAdminBannersIndexRoute,
  StAdminManagementIndexRoute: StAdminManagementIndexRoute,
  StAdminPaymentsIndexRoute: StAdminPaymentsIndexRoute,
  StAdminProfileIndexRoute: StAdminProfileIndexRoute,
  StAdminSettingsIndexRoute: StAdminSettingsIndexRoute,
  StAdminTicketsIndexRoute: StAdminTicketsIndexRoute,
  StAdminTransactionsIndexRoute: StAdminTransactionsIndexRoute,
  StAdminTransferPlayersIndexRoute: StAdminTransferPlayersIndexRoute,
  StAdminUsersIndexRoute: StAdminUsersIndexRoute,
  MarketRelationsBuyersRelationIdRoute: MarketRelationsBuyersRelationIdRoute,
  MarketRelationsSellersRelationIdRoute: MarketRelationsSellersRelationIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_login/login",
        "/_market/dashboard",
        "/st-admin/dashboard",
        "/_market/orders/$orderId",
        "/_market/proxy/new",
        "/_market/relations/buyer",
        "/_market/relations/seller",
        "/_market/senders/$senderId",
        "/_market/senders/new",
        "/_market/orders/",
        "/_market/payment/",
        "/_market/profile/",
        "/_market/proxy/",
        "/_market/relations/",
        "/_market/senders/",
        "/_market/settings/",
        "/st-admin/banners/",
        "/st-admin/management/",
        "/st-admin/payments/",
        "/st-admin/profile/",
        "/st-admin/settings/",
        "/st-admin/tickets/",
        "/st-admin/transactions/",
        "/st-admin/transfer-players/",
        "/st-admin/users/",
        "/_market/relations/buyers/$relationId",
        "/_market/relations/sellers/$relationId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_login/login": {
      "filePath": "_login/login.tsx"
    },
    "/_market/dashboard": {
      "filePath": "_market/dashboard.tsx"
    },
    "/st-admin/dashboard": {
      "filePath": "st-admin/dashboard.tsx"
    },
    "/_market/orders/$orderId": {
      "filePath": "_market/orders/$orderId.tsx"
    },
    "/_market/proxy/new": {
      "filePath": "_market/proxy/new.tsx"
    },
    "/_market/relations/buyer": {
      "filePath": "_market/relations/buyer.tsx"
    },
    "/_market/relations/seller": {
      "filePath": "_market/relations/seller.tsx"
    },
    "/_market/senders/$senderId": {
      "filePath": "_market/senders/$senderId.tsx"
    },
    "/_market/senders/new": {
      "filePath": "_market/senders/new.tsx"
    },
    "/_market/orders/": {
      "filePath": "_market/orders/index.tsx"
    },
    "/_market/payment/": {
      "filePath": "_market/payment/index.tsx"
    },
    "/_market/profile/": {
      "filePath": "_market/profile/index.tsx"
    },
    "/_market/proxy/": {
      "filePath": "_market/proxy/index.tsx"
    },
    "/_market/relations/": {
      "filePath": "_market/relations/index.tsx"
    },
    "/_market/senders/": {
      "filePath": "_market/senders/index.tsx"
    },
    "/_market/settings/": {
      "filePath": "_market/settings/index.tsx"
    },
    "/st-admin/banners/": {
      "filePath": "st-admin/banners/index.tsx"
    },
    "/st-admin/management/": {
      "filePath": "st-admin/management/index.tsx"
    },
    "/st-admin/payments/": {
      "filePath": "st-admin/payments/index.tsx"
    },
    "/st-admin/profile/": {
      "filePath": "st-admin/profile/index.tsx"
    },
    "/st-admin/settings/": {
      "filePath": "st-admin/settings/index.tsx"
    },
    "/st-admin/tickets/": {
      "filePath": "st-admin/tickets/index.tsx"
    },
    "/st-admin/transactions/": {
      "filePath": "st-admin/transactions/index.tsx"
    },
    "/st-admin/transfer-players/": {
      "filePath": "st-admin/transfer-players/index.tsx"
    },
    "/st-admin/users/": {
      "filePath": "st-admin/users/index.tsx"
    },
    "/_market/relations/buyers/$relationId": {
      "filePath": "_market/relations/buyers/$relationId.tsx"
    },
    "/_market/relations/sellers/$relationId": {
      "filePath": "_market/relations/sellers/$relationId.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
